import { createI18n } from "vue-i18n";
import { getDataByFields } from "@/utils/tools.js";

import commonEn from "./en/common.json"
import commonZHCN from "./zh-CN/common.json"
import overviewEn from "./en/overview.json";
import overviewZHCN from "./zh-CN/overview.json";
import apiKeysEn from "./en/apiKeys.json"
import apiKeysZHCN from "./zh-CN/apiKeys.json"
import pricingEn from "./en/pricing.json"
import pricingZHCN from "./zh-CN/pricing.json"
import billingEn from "./en/billing.json"
import billingZHCN  from "./zh-CN/billing.json"

const messages = {
  en: {
    overview: overviewEn,
    common: commonEn,
    apiKeys: apiKeysEn,
    pricing: pricingEn,
    billing: billingEn
  },
  "zh-CN": {
    overview: overviewZHCN,
    common: commonZHCN,
    apiKeys: apiKeysZHCN,
    pricing: pricingZHCN,
    billing: billingZHCN
  }
};

export const mapBrowserLanguage = (appLanguage) => {
  // 获取浏览器的首选语言
  const browserLanguage = appLanguage || navigator.language || navigator.userLanguage;

  // 定义语言映射规则
  const languageMap = {
    en: ["en", "en-US", "en-GB", "en-AU", "en-CA"], // 英语
    'zh-CN': ["zh", "zh-CN", "zh-Hans", "zh-Hant"],// 中文简体
    'zh-TW': [, "zh-HK", "zh-MO", "zh-SG", "zh-TW"], // 中文繁体
    ja: ["ja", "ja-JP"],                            // 日语
    ko: ["ko", "ko-KR"],                            // 韩语
    es: ["es", "es-ES", "es-MX", "es-419"],         // 西班牙语
    pt: ["pt", "pt-BR", "pt-PT"],                   // 葡萄牙语
  };

  // 遍历映射规则，找到最靠近的语言
  for (const [key, values] of Object.entries(languageMap)) {
    if (values.includes(browserLanguage)) {
      return key; // 返回映射的语言代码
    }
  }

  // 如果没有匹配到，返回默认值 (如 "en")
  return "en";
}

const localData =
  localStorage.getItem('skywork_music_ai') || "{}";
const { appLanguage } = JSON.parse(localData);

const language = import.meta.env.VITE_LANGUAGE;
console.log("VITE_LANGUAGE", language);
const i18n = createI18n({
  locale: import.meta.env.VITE_APPNAME == 'Mureka' ? 'en' : 'zh-CN',
  // locale:  'en',
  //appLanguage ?? "en", // 默认语言
  fallbackLocale: "en", // 如果找不到当前语言的翻译，默认回退到的语言
  messages,
});

export const $$t = (key, language, params) => {
  if (language && Object.keys(messages).includes(language)) {
    return getDataByFields(messages[language], key, params);
  } else {
    return i18n.global.t(key, params);
  }
};

export const $$tValue = (key, params) => {  // 替换‘text{key}’ ,{key:value}格式
  return i18n.global.t(key, params);
}

export const $$language = (language) => {
  if (language && Object.keys(messages).includes(language)) {
    if (i18n.global.locale != language) {
      let old = i18n.global.locale;
      i18n.global.locale = language;
      setTimeout(() => {
        triggleBrodcastEvent("languageChange", language, old);
      }, 1);
    }
  }
  return i18n.global.locale;
};

const languageChangeListeners = [];
const triggleBrodcastEvent = (type, language) => {
  languageChangeListeners.forEach((listener) => {
    listener(type, language);
  });
};

export const $$registLanguageChangeListener = (listener) => {
  languageChangeListeners.push(listener);
};

export const $$removeLanguageChangeListener = (listener) => {
  const index = languageChangeListeners.indexOf(listener);
  if (index > -1) {
    languageChangeListeners.splice(index, 1);
  }
};
export const LanguageList = [
  {
    key: "en",
    label: "English",
  },
  {
    key: "zh-CN",
    label: "中文（简体）",
  },
  {
    key: "zh-TW",
    label: "中文（繁體）",
  },
  {
    key: "ja",
    label: "日本語",
  },
  {
    key: "ko",
    label: "일본어",
  },
  {
    key: "es",
    label: "Español",
  },
  {
    key: "pt",
    label: "Português",
  },

]

export const LanguageListMap = {
  // cn: [
  //   {
  //     key: "cn",
  //     label: "中文",
  //   },
  //   {
  //     key: "en",
  //     label: "英语",
  //   },
  //   {
  //     key: "ja",
  //     label: "日语",
  //   },
  //   {
  //     key: "ko",
  //     label: "韩语",
  //   },
  //   {
  //     key: "es",
  //     label: "西班牙语",
  //   },
  //   {
  //     key: "pt",
  //     label: "葡萄牙语",
  //   },
  // ],
  en: [
    // {
    //   key: "cn",
    //   label: "Chinese",
    // },
    {
      key: "en",
      label: "English",
    },
    {
      key: "ja",
      label: "Japanese",
    },
    {
      key: "ko",
      label: "Korean",
    },
    {
      key: "es",
      label: "Spanish",
    },
    {
      key: "pt",
      label: "Portuguese",
    },
  ],
  ja: [
    // {
    //   key: "cn",
    //   label: "中国語",
    // },
    {
      key: "en",
      label: "英語",
    },

    {
      key: "ja",
      label: "日本語",
    },
    {
      key: "ko",
      label: "韓国語",
    },
    {
      key: "es",
      label: "スペイン語",
    },
    {
      key: "pt",
      label: "ポルトガル語",
    },
  ],
  ko: [
    // {
    //   key: "cn",
    //   label: "중국어",
    // },
    {
      key: "en",
      label: "영어",
    },
    {
      key: "ja",
      label: "일본어",
    },
    {
      key: "ko",
      label: "한국어",
    },
    {
      key: "es",
      label: "스페인어",
    },
    {
      key: "pt",
      label: "포르투갈어",
    },
  ],
  es: [
    // {
    //   key: "cn",
    //   label: "Chino.",
    // },
    {
      key: "en",
      label: "Inglés",
    },
    {
      key: "ja",
      label: "japonés",
    },
    {
      key: "ko",
      label: "Coreano",
    },

    {
      key: "es",
      label: "Español",
    },
    {
      key: "pt",
      label: "Portugués",
    },
  ],
  pt: [
    // {
    //   key: "cn",
    //   label: "Chinês",
    // },
    {
      key: "en",
      label: "Inglês",
    },
    {
      key: "ja",
      label: "Japonês",
    },
    {
      key: "ko",
      label: "Coreano",
    },
    {
      key: "es",
      label: "Espanhol",
    },
    {
      key: "pt",
      label: "Português",
    },
  ],
};

export default i18n;
